/// <amd-module name="TFS/Samples/MasterDetails/LayerComponents/PullRequest/PullRequestLayer" />
import * as React from "react";
import { ObservableValue } from "VSS/Core/Observable";
import { createChildAwareLayer, createHistoryAwareLayer } from "VSS/Features/MasterDetails";
import { IVssPageContext } from "VSS/Platform/Context";
import { MasterPanelHeader } from "VSSUI/MasterDetails";
import { IMasterDetailsContextLayer } from "VSSUI/MasterDetailsContext";
import { IPullRequest, SampleData } from "../../SampleData";
import { getCommitLayer } from "../Commit/CommitLayer";
import { PullRequestDetailsContent } from "./PullRequestDetailsContent";
import { PullRequestMasterContent } from "./PullRequestMasterContent";

export function getPullRequestLayer(pullRequest: IPullRequest, pageContext: IVssPageContext): IMasterDetailsContextLayer<IPullRequest, undefined> {
    return createChildAwareLayer(
        createHistoryAwareLayer(
            {
                key: "pull-request",
                selectedMasterItem: new ObservableValue<IPullRequest>(pullRequest),
                detailsContent: {
                    renderContent: (selectedItem: IPullRequest) => <PullRequestDetailsContent pullRequest={selectedItem} />
                },
                masterPanelContent: {
                    renderHeader: () => <MasterPanelHeader title={"Pull Requests"} />,
                    renderContent: (parentItem, initialSelectedMasterItem) => (
                        <PullRequestMasterContent initialSelectedMasterItem={initialSelectedMasterItem} />
                    )
                }
            },
            pageContext,
            pullRequest => pullRequest.hashCode,
            (itemAsString: string) => SampleData.find(x => x.hashCode === itemAsString)!
        ),
        "commit",
        (commitAsString: string) => {
            const selectedCommit = pullRequest.commits.find(commit => commit.hashCode === commitAsString);
            if (selectedCommit) {
                return getCommitLayer(selectedCommit, pullRequest, pageContext);
            }
            return undefined;
        },
        pageContext
    );
}
